/** Slug format expected by backend GET /profile/:public_slug (UUID suffix). */
export function buildPublicProfileSlug(user: {
  user_id: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
}): string {
  const rawName =
    user.full_name?.trim() ||
    [user.first_name, user.last_name].filter(Boolean).join(" ").trim() ||
    "profile";

  const namePart = rawName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `${namePart || "profile"}-${user.user_id}`;
}

export function getPublicProfileUrl(slug: string): string {
  const base =
    import.meta.env.VITE_PUBLIC_PROFILE_BASE_URL?.replace(/\/$/, "") ||
    import.meta.env.VITE_PUBLIC_PROFILE_URL?.replace(/\/$/, "") ||
    "https://memorique.com";

  return `${base}/profile/${slug}`;
}

export function getReferralUrl(hash: string): string {
  const base =
    import.meta.env.VITE_PUBLIC_PROFILE_BASE_URL?.replace(/\/$/, "") ||
    import.meta.env.VITE_PUBLIC_PROFILE_URL?.replace(/\/$/, "") ||
    "https://memorique.com";

  return `${base}/referral/${hash}`;
}

export function getUserReferralHash(
  user?: {
    user_hash?: string | null;
    referral_hash?: string | null;
  } | null,
): string {
  return user?.user_hash?.trim() || user?.referral_hash?.trim() || "";
}

export function getReferralUrlForUser(
  user?: {
    user_hash?: string | null;
    referral_hash?: string | null;
  } | null,
): string {
  const hash = getUserReferralHash(user);
  return hash ? getReferralUrl(hash) : "";
}
